import { render, staticRenderFns } from "./delivery-overrides.vue?vue&type=template&id=6ae91752"
import script from "./delivery-overrides.vue?vue&type=script&lang=js"
export * from "./delivery-overrides.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports